module.exports = __webpack_public_path__ + "img/historico.c82159d5.svg";